import React from "react";
import PageBase from "../components/PageBase";
import { Helmet } from "react-helmet";

const today = new Date();
const thisYear = today.getFullYear();

const GureTaldea = () => {
  const styles = {
    images: {
      maxWidth: "100%",
    },
  };

  return (
    <PageBase
      title="Aloña Mendi K.E. Triatloi Taldea"
      navigation="Oñatiko Duatloi Txikia / Aloña Mendi K.E. Triatloi Taldea"
    >
      <Helmet>
        <title>Aloña Mendi K.E. Triatloia</title>
        <meta
          name="description"
          content={`1991 urtean, triatloia gustoko zuen Oñatiko lagun talde bat elkartu eta inguruko frogetan parte hartzeaz gain Oñatiko Duatloia antolatzen hasi ziren. ${
            thisYear - 1991
          } urte baino gehiago igaro dira eta bide berdinetik jarraitzen dugu gaur egun.`}
        />
        <meta property="og:title" content="Aloña Mendi K.E. Triatloia" />
        <meta
          property="og:description"
          content={`1991 urtean, triatloia gustoko zuen Oñatiko lagun talde bat elkartu eta inguruko frogetan parte hartzeaz gain Oñatiko Duatloia antolatzen hasi ziren. ${
            thisYear - 1991
          } urte baino gehiago igaro dira eta bide berdinetik jarraitzen dugu gaur egun.`}
        />
        <meta
          property="og:url"
          content="http://duatloitxikia.oinatikoduatloia.com/guretaldea"
        />
        <meta
          property="og:image"
          content="http://duatloitxikia.oinatikoduatloia.com/taldea.png"
        />
      </Helmet>

      <p>
        1991 urtean, triatloia gustoko zuen Oñatiko lagun talde bat elkartu eta
        inguruko frogetan parte hartzeaz gain Oñatiko Duatloia antolatzen hasi
        ziren. {today.getFullYear() - 1991} urte baino gehiago igaro dira eta
        bide berdinetik jarraitzen dugu gaur egun.
      </p>
      <p>
        <center>
          <img
            src="https://static.alonamendi.eus/media/ckeditor/triatloia/2020/06/06/mungia-2020.jpeg"
            style={styles.images}
          />
        </center>
      </p>
      <br />
      <p>
        <center>
          <img src={require("../images/taldea.png")} style={styles.images} />
        </center>
      </p>
      <p>
        Taldeko webgunea:{" "}
        <a href="http://www.aloñamendi.eus/triatloia" target="_blank">
          Aloña Mendi K.E. Triatloia
        </a>
      </p>
    </PageBase>
  );
};

export default GureTaldea;



/** WEBPACK FOOTER **
 ** ./src/containers/GureTaldea.js
 **/